<app-main-page>
  <h1>Willkommen im NZZ Connect Backend!</h1>
</app-main-page>
